import { Taxonomy } from "../common/categories";
import { useStandardCategories } from "./useStandardCategories";

export function useUncategorizedCategory() {
    const standardCategories = useStandardCategories();

    return standardCategories[Taxonomy.uncategorized];
}
